// extracted by mini-css-extract-plugin
module.exports = {"container":"topMatch__container___1gvuF","header":"topMatch__header___3_hQu","header-title":"topMatch__header-title___3I1Qx","spinner":"topMatch__spinner___3Wnh7"};